var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isImage)?_c('image-slide',{attrs:{"content":_vm.content}}):_vm._e(),_vm._v(" "),(_vm.isVideo)?_c('video-slide',{attrs:{"content":_vm.content}}):_vm._e(),_vm._v(" "),(_vm.isBanner)?_c('banner-slide',{attrs:{"content":_vm.content}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-053a68ab","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/Slide.vue
// module id = 228
// module chunks = 0